export default "__VITE_ASSET__DgNg3TBn__"